import {useState} from "react";

const ObjectDataHolder = (initialObject) => {
  const [data, setData] = useState(initialObject !== undefined ? initialObject : {})
  const dataSetter = (keyValuePairsOrUpdater) => {
    if (typeof keyValuePairsOrUpdater === 'function') {
      setData(prev => ({...prev, ...keyValuePairsOrUpdater(prev)}))
    } else {
      setData(prev => ({...prev, ...keyValuePairsOrUpdater}))
    }
  }
  return [data, dataSetter];
}
export default ObjectDataHolder;